export default {
  namespaced: true,
  state: {
    name: '报名系统',
    version: '0.1'
  }
}